window.autoGift = {
  initialized: false,
  processing: false,
  internalUpdate: false,
  config: null,

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.loadConfig();
    this.observeCartChanges();
    this.validateCart();

    console.log('Auto Gift initialized');
  },

  loadConfig() {
    const configElement = document.getElementById('auto-gift-config');
    if (!configElement) return;

    try {
      this.config = JSON.parse(configElement.textContent);
      console.log('Auto Gift config:', this.config);
    } catch (error) {
      console.error('Auto Gift config error', error);
    }
  },

  // Antes: listeners globales click/change que competían con el render del tema.
  // Ahora: observamos las superficies reales del carrito (el drawer, que es global,
  // y main-cart-items, que solo existe en /cart). Solo reaccionamos DESPUES del
  // render del tema, eliminando la carrera.
  observeCartChanges() {
    this.observer = new MutationObserver(() => {
      if (this.internalUpdate) return; // ignorar nuestros propios renders
      clearTimeout(this.cartTimer);
      this.cartTimer = setTimeout(() => this.validateCart(), 250);
    });

    const opts = { childList: true }; // sin subtree: solo re-renders completos del body

    const drawerBody = document.querySelector('#CartDrawer-Body');
    if (drawerBody) this.observer.observe(drawerBody, opts);

    const mainCart = document.getElementById('main-cart-items');
    if (mainCart) this.observer.observe(mainCart, opts);
  },

  async getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  },

  async getSections() {
    // GET con timestamp para evitar CDN cache. Solo secciones globales —
    // la sección de /cart requiere contexto de página y se actualiza via postCart.
    const names = this.getRenderTargets()
      .filter(t => t.name === 'cart-drawer' || t.name === 'cart-counter')
      .map(t => t.name)
      .join(',');
    const response = await fetch(`/?sections=${names}&_=${Date.now()}`, {
      cache: 'no-store'
    });
    return response.json();
  },

  async validateCart() {
    if (this.processing) return;
    if (!this.config) return;
    this.processing = true;
    this.mutated = false;

    try {
      let cart = await this.getCart();
      const promotions = this.config.promotions || [];

      for (let i = 0; i < promotions.length; i++) {
        const promotion = promotions[i];

        if (!promotion.enabled || !promotion.giftVariantId) continue;

        const qualifies = this.cartQualifies(cart, promotion);
        const giftInCart = cart.items.find(
          item => item.variant_id === promotion.giftVariantId
        );

        console.log('Promotion:', promotion);
        console.log('Qualifies:', qualifies);
        console.log('Gift in cart:', !!giftInCart);

        // AGREGAR
        if (qualifies && !giftInCart) {
          console.log('Adding gift');
          await this.addGift(promotion.giftVariantId);
          cart = await this.getCart(); // refrescar para promos siguientes
          this.mutated = true;
          continue;
        }

        // REMOVER
        if (!qualifies && giftInCart) {
          console.log('Removing gift');
          await this.removeGift(giftInCart.key);
          cart = await this.getCart(); // refrescar para promos siguientes
          this.mutated = true;
          continue;
        }

        // LIMITAR
        if (giftInCart && giftInCart.quantity > 1) {
          await this.updateLineItem(giftInCart.key, 1);
          cart = await this.getCart(); // refrescar para promos siguientes
          this.mutated = true;
        }
      }
    } catch (error) {
      console.error('Auto Gift Error:', error);
    } finally {
      // Reconcile: corre con processing=true para evitar validates concurrentes.
      // Corrige renders externos que sobrescribieron el drawer durante nuestra ejecución.
      try {
        const sections = await this.getSections();
        this.applySections(sections);
      } catch (e) { /* no crítico */ }

      this.processing = false;

      // Catch-up: si hubo mutaciones, una 2da pasada 50ms después del finally
      // atrapa renders externos que cayeron en la ventana internalUpdate del reconcile.
      // La 2da pasada no tiene mutaciones → mutated=false → no agenda 3ra pasada.
      if (this.mutated) {
        clearTimeout(this.catchUpTimer);
        this.catchUpTimer = setTimeout(() => this.validateCart(), 50);
      }
    }
  },

  cartQualifies(cart, promotion) {
    let totalEligibleQuantity = 0;

    cart.items.forEach(item => {
      // excluir regalo actual
      if (item.variant_id === promotion.giftVariantId) return;

      const eligibleProduct = promotion.eligibleProducts[item.product_id];
      if (!eligibleProduct) return;

      const equivalentQty = eligibleProduct.equivalentQty || 1;
      totalEligibleQuantity += equivalentQty * item.quantity;
    });

    console.log('Eligible quantity:', totalEligibleQuantity);

    return totalEligibleQuantity >= promotion.requiredQty;
  },

  async addGift(variantId) {
    const sections = await this.postCart('/cart/add.js', {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: { '_auto_gift': 'true' }
        }
      ]
    });
    this.applySections(sections);
  },

  async removeGift(key) {
    const sections = await this.postCart('/cart/change.js', {
      id: key,
      quantity: 0
    });
    this.applySections(sections);
  },

  async updateLineItem(key, quantity) {
    const sections = await this.postCart('/cart/change.js', {
      id: key,
      quantity: quantity
    });
    this.applySections(sections);
  },

  // Superficies del carrito presentes en la página actual.
  // El drawer es global; main-cart-items solo existe en /cart.
  // Pedimos/renderizamos solo lo que existe, igual que getSectionsToRender del tema.
  getRenderTargets() {
    const targets = [
      {
        name: 'cart-counter',
        live: '#cart-counter',
        parse: '#shopify-section-cart-counter',
        fallbackParse: '#shopify-section-cart-counter'
      }
    ];

    if (document.querySelector('#CartDrawer-Body')) {
      targets.push({
        name: 'cart-drawer',
        live: '#shopify-section-cart-drawer #CartDrawer-Body',
        parse: '#shopify-section-cart-drawer #CartDrawer-Body',
        fallbackParse: '#CartDrawer-Body'
      });
    }

    const mainCart = document.getElementById('main-cart-items');
    if (mainCart && mainCart.dataset.id) {
      const id = mainCart.dataset.id;
      targets.push({
        name: id,
        live: `#shopify-section-${id} cart-items`,
        parse: `#shopify-section-${id} cart-items`,
        fallbackParse: '#main-cart-items'
      });
    }

    return targets;
  },

  // Pide las secciones renderizadas EN LA MISMA respuesta de la mutación,
  // igual que hace el tema en CartItems.updateQuantity. Sin GET aparte.
  async postCart(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ...payload,
        sections: this.getRenderTargets().map(target => target.name),
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();
    return data.sections;
  },

  // Aplica el render con el mismo patrón/selectores del tema, sobre cada superficie
  // presente. El estado vacío viene dentro de #CartDrawer-Body, así que no hay clase
  // que togglear.
  applySections(sections) {
    if (!sections) return;

    this.internalUpdate = true;

    const parser = new DOMParser();

    this.getRenderTargets().forEach(target => {
      const html = sections[target.name];
      if (!html) return;

      const liveEl = document.querySelector(target.live);
      const doc = parser.parseFromString(html, 'text/html');
      const parsedEl =
        doc.querySelector(target.parse) ||
        doc.querySelector(target.fallbackParse);

      if (liveEl && parsedEl) {
        liveEl.innerHTML = parsedEl.innerHTML;
      }
    });

    // Limpiar el flag tras drenar el batch de mutaciones del observer (microtask).
    setTimeout(() => {
      this.internalUpdate = false;
    }, 0);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.autoGift.init();
});

// HIDE PRODUCTS
function hideGiftProducts() {
  const hiddenHandles = [
    'headband-gianni-grey-taupe',
    'headband-gianni-blue-navy'
  ];

  hiddenHandles.forEach(handle => {
    const links = document.querySelectorAll(`a[href*="/products/${handle}"]`);

    links.forEach(link => {
      // Solo ocultar en listados (colecciones, búsqueda). Nunca dentro del
      // carrito, drawer o recomendaciones: ahí el regalo es un item legítimo,
      // y el walk-up podría ocultar #CartDrawer-Body entero.
      if (
        link.closest(
          'cart-drawer, #CartDrawer-Body, #main-cart-items, cart-recommendations, [data-recommendations]'
        )
      ) {
        return;
      }

      let parent = link;

      // subir varios niveles
      for (let i = 0; i < 10; i++) {
        if (!parent) break;

        const hasImage = parent.querySelector('img');
        const hasPrice = parent.innerText.includes('COP');

        if (hasImage && hasPrice) {
          parent.style.display = 'none';
          break;
        }

        parent = parent.parentElement;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  hideGiftProducts();

  let hideTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideGiftProducts, 200);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});